import React, { useEffect, useContext } from 'react';
import PropTypes from "prop-types";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { calculateTax, calculateTotalPriceFromBookingConfig, formatPrice } from "../../../../Helpers/PaymentHelper";
import OptionalFormSection from "../../../../Components/HorizontalForm/OptionalFormSection";
import { BookingFormContext } from "../BookingFormProvider";
import BookingFormTermsConditions from "./BookingFormTermsConditions";
import ActionButton from "../../../../Components/Buttons/ActionButton";

const BookingFormPaymentSection = (props) => {

    const {
        booking,
        bookingConfig,

        bookingInProgress,
        isSubmitDisabled,
        onSubmitClick,

        editBookingId,
    } = useContext(BookingFormContext);

    const [subTotal, setSubTotal] = React.useState();
    const [tax, setTax] = React.useState();
    const [total, setTotal] = React.useState();

    useEffect(() => {
        if (!booking || !bookingConfig) {
            return;
        }

        const total = calculateTotalPriceFromBookingConfig(booking, bookingConfig);
        setTotal(total);
        const tax = calculateTax(total);
        setTax(tax)
        setSubTotal(total - tax);

    }, [bookingConfig.payment_amount, booking.start, booking.end]);

    if (!bookingConfig?.payment_enabled) {
        return null;
    }

    return (<>
        <OptionalFormSection
            title="Booking Fee"
            isCollapsible={false}
        >
            <FormRow
                label="Sub-total (excl. VAT)"
                leftCellClassName="small-12 medium-5"
                rightCellClassName="small-12 medium-7 text-right"
            >
                <span className="text-lg">
                    {formatPrice(subTotal, bookingConfig.payment_currency_symbol)}
                </span>
            </FormRow>

            <FormRow
                label="VAT"
                leftCellClassName="small-12 medium-5"
                rightCellClassName="small-12 medium-7 text-right"
            >
                <span className="text-sm">
                    {formatPrice(tax, bookingConfig.payment_currency_symbol)}
                </span>
            </FormRow>

            <FormRow
                label="Total"
                leftCellClassName="small-12 medium-5 text-bold"
                rightCellClassName="small-12 medium-7 text-right"
            >
                <strong className="text-lg">
                    {formatPrice(total, bookingConfig.payment_currency_symbol)}
                </strong>
            </FormRow>
        </OptionalFormSection>

        <section className="section form-container full">
            <BookingFormTermsConditions/>

            <ActionButton
                type="button"
                title={`Proceed to payment`}
                labelRight={formatPrice(total, bookingConfig.payment_currency_symbol)}
                className="button primary expanded label-right-lg"
                onClick={onSubmitClick}
                isDisabled={isSubmitDisabled()}
                animateOnClick
                preventMultipleClicks
            />
        </section>
    </>);
};

BookingFormPaymentSection.propTypes = {};

BookingFormPaymentSection.defaultProps = {};

export default BookingFormPaymentSection;
